module.exports = __webpack_public_path__ + "static/img/Unibox.0b323d5.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/offer/Unibox.png
// module id = 51
// module chunks = 1 2